import styled from "styled-components"

export const SGSocialWrapper = styled.div``;

export const SGFirstButtonWrapper = styled.div`
  width: 100%;

  img {
    width: 100%;
  }
`;

export const SGSecondButtonWrapper = styled.div`
  width: 100%;
  margin-top: 25px;
  img {
    width: 100%;
  }
`;

export const SGHeadingWrapper = styled.div`
  width: 100%;
  margin-top: 40px;
  img {
    width: 100%;
  }
`;
export const SGSocialIconsWrapper = styled.div`
  width: 100%;
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 18%;
  }
`;
